module.exports = __webpack_public_path__ + "static/media/ring.68f07038.gif";